import styled from 'styled-components';

export const Logo = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;

  img {
    width: var(--theme-palette-logo-width, 90px);
    height: var(--theme-palette-logo-height, 48px);
    max-height: 50px;
  }
`;
